import React from 'react';

function TitleComponent({ type, title }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span style={{
        fontWeight: '400',
        color: '#404040',
        fontSize: 12,
        marginBottom: 8,
      }}
      >
        {type}
      </span>
      <span style={{
        fontWeight: '800',
        color: '#2AABDF',
        fontSize: 20,
      }}
      >
        {title}
      </span>
    </div>

  );
}

export default TitleComponent;
